import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { capitalizeAndRemoveUnderscores, limitWords, downloadFile, convertIntoFormData, decryptByLink } from "../../utils/utils";
import { motion } from 'framer-motion';
import {
  Descriptions,
  Input,
  InputNumber,
  Button,
  message,
  DatePicker,
  Popconfirm,
  Form,
  Modal,
  Card,
  Row,
  Col,
  Upload,
  Table,
  Tabs,
  Tooltip,
  Select,
  FloatButton,
  Popover,
  Space,
  Spin,
  AutoComplete,
  Alert,
  Result,
  Tag,
} from "antd";
import dayjs from "dayjs";
import {
  EditOutlined,
  ArrowLeftOutlined,
  ExportOutlined,
  MailOutlined,
  DownloadOutlined,
  MoreOutlined,
  HighlightOutlined,
  IdcardOutlined,
  UploadOutlined,
  PictureOutlined,
  FileTextOutlined,
  PlusOutlined, PlusCircleOutlined, DeleteOutlined,
  SendOutlined
} from '@ant-design/icons';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { agreementOptions, BASE_URL } from "../../utils/Constant";
import ButtonComp from "../../components/button/ButtonComp";
import { formatIndianDate } from "../../utils/Constant";
import SelectComponent from "../../components/select/SelectComponent";
import { findMaxIndex } from "../../utils/utils";
import MasterTemplateModal from "../masterTemplate/MasterTempModal";
import ClausesModal from "../clauseTemplate/clauseTemplateModal";
import { Typography } from "antd";
import { parseDuration } from '../../utils/utils'
import { useLocation } from 'react-router-dom';  // For React Router v6
import EditProductsTab from "./Tabs/editProductsTab";
import SentAgreementModel from "./model/sentAgreementModel";
import Chat from "./Chat/Chat";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import EyeOutlineIcon from "../../components/icons/EyeOutlineIcon";
import FileTextIcon from "../../components/icons/FileTextIcon";
const { Text } = Typography;

dayjs.extend(customParseFormat);
const dateFormat = "DD-MM-YYYY";
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

function ContractDetailComp() {
  const [years, setYears] = useState();
  const [months, setMonths] = useState();
  const [days, setDays] = useState();
  const navigate = useNavigate();
  const params = useParams();
  const [contract, setContract] = useState();
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMasterLoading, setIsMasterLoading] = useState(false);
  const [isClauseLoading, setIsClauseLoading] = useState(false);
  const [clausesData, setClausesData] = useState([]);
  const [masterClausesData, setMasterClausesData] = useState([]);
  const [countries, setCountries] = useState();
  const [states, setStates] = useState();
  const [clientStates, setClientStates] = useState();
  const [partyStates, setPartyStates] = useState();
  const [uploading, setUploading] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [masterTempUploading, setMasterTempUploading] = useState(false);
  const [editedContract, setEditedContract] = useState({});
  const [isSendModalVisible, setIsSendModalVisible] = useState(false);
  const [isThirdPartyVisible, setIsThirdPartyVisible] = useState(false);
  const [isDifferentUser, setIsDifferentUser] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [masterTempModal, setMasterTempModal] = useState(false);
  const [clauseTempModal, setClauseTempModal] = useState(false);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [companyDiffUsers, setCompanyDiffUsers] = useState([]);
  const [masterTemplateData, setMasterTemplateData] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [isOpnSentAgreement, setIsOpnSentAgreement] = useState(false);
  const [customFields, setCustomFields] = React.useState([]);
  const [agreementFileBeforeEsign, setAgreementFileBeforeEsign] = useState("")
  const [attachments, setAttachments] = useState();
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [fileName, setFilename] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [productEditMode, setProductEditMode] = useState(false);
  const [customModal, setCustomModal] = useState(false);
  const [formFields, setFormFields] = useState([{ id: 1, value: "" }]);
  const [finalPage, setFinalPage] = useState(6);
  const [isUserAddModalVisible, setIsUserAddModalVisible] = useState(false);
  const [dueDate, setDueDate] = useState(contract && contract.payment_due_date);
  const [effectiveDate, setEffectiveDate] = useState(
    contract && contract.effective_date
  );
  const [executionDate, setExecutionDate] = useState(
    contract && contract.date_of_execution
  );
  const [dateModalVisible, setDateModalVisible] = useState(false);
  const [signuluResponse, setSignuluResponse] = useState({});
  const queryParams = new URLSearchParams(window.location.search);
  const referrer = queryParams.get("referrer");
  const [esignDetailModalOpen, setEsignDetailModalOpen] = useState(false);
  const [isModifyOpen, setModifyOpen] = useState(false);
  const [isReminderLoading, setIsReminderLoading] = useState(false);
  const [pendingEmails, setPendingEmails] = useState([]);
  const [documentId, setDocumentId] = useState([]);
  const [errorMessageShown, setErrorMessageShown] = useState(false);
  const [SendContractForm] = Form.useForm();
  const [CounterPartyForm] = Form.useForm();
  const [differentUserForm] = Form.useForm();
  const [customFieldsForm] = Form.useForm();
  const [addUserForm] = Form.useForm();
  const [addAttachmentsForm] = Form.useForm();
  const location = useLocation();
  const warMdlType = useRef(null);
  const warMdlBod = useRef('');
  const uploadRef = useRef(null)
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "1"
  const [activeTab, setActiveTab] = useState(initialTab);
  const tab = searchParams.get("tab");
  const select = useSelector((state) => state.auth.userInfo);
  const user_role = select.role;
  const user_email = select.user_email;
  const user_id = select.user_id;
  const [isLinkedModalVisible, setIsLinkedModalVisible] = useState(false);
  const [errorinContractGet, setErrorinContractGet] = useState(null);
  const [hasBeenShown, setHasBeenShown] = useState(false);
  const { Option } = Select;
  const [compareMode, setCompareMode] = useState(false);
  const [selectedPrev, setSelectedPrev] = useState(null);
  const [selectedCurr, setSelectedCurr] = useState(null);

  let canShowErrorMessage = true; // Flag to control showing the error message
  let updatedCustomForm = useMemo(() => contract ? { ...contract.custom_field } : {}, [contract?.custom_field])
  const dropdownStyle = {
    width: "auto", // Allow the dropdown to adjust its width based on content
    minWidth: "150px", // Set a minimum width if needed
    maxWidth: "300px", // Set a maximum width if needed
  };
  const pathname =
    referrer === "dashboard"
      ? "/admin/dashboard"
      : referrer === "audit-trail"
        ? "/admin/dashboard/audit-trail"
        : "/admin/contracts";

  const userRole = user_role;
  const role = userRole && userRole.toLowerCase();
  let statusOptions = [];
  if (contract) {
    statusOptions = [
      ...(contract.is_draft ? [{ value: "FRESH_REQUEST", label: "Fresh Request" }] : []),
      { value: "UNDER_NEGOTIATION", label: "Under Negotiation" },
      { value: "UNDER_EXECUTION", label: "Under Execution" },
      ...(role && (role.toLowerCase() === "agreement controller team" || role.toLowerCase() === "agreement controller head")
        ? [{ value: "EXECUTED", label: "Executed" }]
        : []),
      ...(user_email === contract.created_by
        ? [{ value: "TRANSACTION_CLOSED", label: "Transaction Closed" }]
        : []),
    ];
  }
  if (role.toLowerCase() === "businessteam") {
    statusOptions = statusOptions.filter(
      (option) => option.value !== "EXECUTED"
    );
  }
  const natureOptions = [
    { value: "customer", label: "Customer" },
    { value: "vendor", label: "Vendor" },
    { value: "partnership", label: "Partnership" },
  ];
  const dataCopy = { ...editedContract };
  delete dataCopy.company;
  delete dataCopy.agreement;
  delete dataCopy.contract_access_users;
  delete dataCopy.created_by;
  delete dataCopy.created_at;
  delete dataCopy.date_of_execution;
  delete dataCopy.expiry_date;
  delete dataCopy.id;
  delete dataCopy.modified_at;
  delete dataCopy.party_name;
  delete dataCopy.term_sheet;
  delete dataCopy.user_name;
  const countryId =
    dataCopy &&
    dataCopy.party_address &&
    dataCopy.party_address.country &&
    dataCopy.party_address.country.id;
  const stateId =
    dataCopy &&
    dataCopy.party_address &&
    dataCopy.party_address.state &&
    dataCopy.party_address.state.id;
  const clientCountryId =
    dataCopy &&
    dataCopy.client_address &&
    dataCopy.client_address.country &&
    dataCopy.client_address.country.id;

  const clientStateId =
    dataCopy &&
    dataCopy.client_address &&
    dataCopy.client_address.state &&
    dataCopy.client_address.state.id;

  const newData = {
    ...dataCopy,
    party_address: {
      ...dataCopy.party_address,
      country: countryId,
      state: stateId,
    },

    client_address: {
      ...(dataCopy.client_address || {}),
      ...(clientCountryId && { country: clientCountryId }),
      ...(clientStateId && { state: clientStateId }),
      ...(dataCopy.client_address?.address1 && {
        address1: dataCopy.client_address.address1,
      }),
      ...(dataCopy.client_address?.address2 && {
        address2: dataCopy.client_address.address2,
      }),
      ...(dataCopy.client_address?.city && {
        city: dataCopy.client_address.city,
      }),
      ...(dataCopy.client_address?.postal_code && {
        postal_code: dataCopy.client_address.postal_code,
      }),
    },
    effective_date: effectiveDate && effectiveDate,
    date_of_execution: executionDate && executionDate,
    payment_due_date: dueDate && dueDate,
  };

  const esignColumns = [
    {
      title: "Signed By",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => (
        <>
          <Tooltip title={text}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {limitWords(text, 100)}
            </div>
          </Tooltip>
        </>
      ),
    },
    {
      title: "Signature Image",
      dataIndex: "signatureImage",
      ellipsis: true, // Enable ellipsis for the column
      render: (text) => <img src={text} alt="sign" className="h-20" />,
    },
    {
      title: "Signature Status",
      dataIndex: "status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
  ];
  let shownReminders = true;
  let shouldShowGlobalReminder = true;

  const handleChangeView = async (prev, curr) => {
    try {
      setHasBeenShown(true);
      if (!prev || !curr) {
        message.error("Both previous and current file must be selected.");
        return;
      }
      const res = await axiosInstance.post(`contract/added-lines/`, {
        previous_agreement_url: prev?.url,
        current_agreement_url: curr?.url,
      });

      const diffUrl = res?.data?.highlighted_diff_url;

      if (diffUrl) {
        const encodedUrl = encodeURIComponent(diffUrl);
        window.open(`/version-diff-viewer?file=${encodedUrl}`, "_blank");
      } else {
        message.warning("No differences found.");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to fetch the differences.";
      message.error(errorMsg);
      console.error("handleChangeView Error:", error);
    } finally {
      setHasBeenShown(false);
    }
  };

  const handleTrackChangeView = async (diffUrl) => {
    try {
      if (diffUrl) {
        const encodedUrl = encodeURIComponent(diffUrl);
        window.open(`/version-diff-viewer?file=${encodedUrl}`, "_blank");
      } else {
        message.warning("No differences found.");
      }
    } catch (error) {
      message.error(error.message || "Failed to fetch the differences.");
    } finally {
      setHasBeenShown(false);
    }
  };


  const columns = [
    {
      title: "Initiator",
      dataIndex: "modification_user_name",
    },
    {
      title: "Contributor",
      dataIndex: "contributor_name",
      ellipsis: true,
      render: (text, record, index) => {
        const thirdPartyId = record?.third_party;
        const isNotSent = record?.is_sent_to_third_party === false;
        const isSent = record?.is_sent_to_third_party === true;
        if (isSent) {
          shouldShowGlobalReminder = false;
        }
        const showReminder = thirdPartyId && isNotSent && shownReminders && shouldShowGlobalReminder;
        if (showReminder) {
          shownReminders = false;
        }
        return (
          <Tooltip title={text?.toString()}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                padding: "10px",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {limitWords(text?.toString())}
              {showReminder && (
                <Tooltip title="Email Reminder" placement="right">
                  <MailOutlined
                    className="text-2xl cursor-pointer"
                    onClick={() => sendEmailReminder(text)}
                  />
                </Tooltip>
              )}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      ellipsis: true, // Enable ellipsis for the column
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 9)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Current Status",
      dataIndex: "current_status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
    {
      title: "Previous Status",
      dataIndex: "previous_status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
    {
      title: (
        <div>
          Modified On Date <br />
        </div>
      ),
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => formatIndianDate(date),
    },
    {
      title: "Current Version",
      dataIndex: "agreement",
      render: (text, record) => {
        const isSelected = selectedCurr?.rowId === record.key;
        return (
          <Tooltip title={compareMode ? "Click to select as Current" : "Download"}>
            <Button
              onClick={() => {
                const url = record.current_agreement;
                const rowId = record.key;

                if (!compareMode) {
                  onVersionControlDownload(url);
                  return;
                }

                setSelectedCurr((prev) =>
                  prev?.rowId === rowId ? null : { rowId, url }
                );
              }}
              style={{
                backgroundColor: isSelected ? "#ffe58f" : "",
                border: "none", // ⬅️ No border
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                boxShadow: isSelected ? "0 0 0 2px #d48806" : "none", // optional glow
                borderRadius: "6px", // optional round
              }}
            >
              <FileTextIcon />
            </Button>
          </Tooltip>
        );
      },
    },

    {
      title: "Previous Version",
      dataIndex: "agreement",
      render: (text, record) => {
        const isSelected = selectedPrev?.rowId === record.key;
        return (
          <Tooltip title={compareMode ? "Click to select as Previous" : "Download"}>
            <Button
              onClick={() => {
                const url = record.previous_agreement;
                const rowId = record.key;

                if (!compareMode) {
                  onVersionControlDownload(url);
                  return;
                }

                setSelectedPrev((prev) =>
                  prev?.rowId === rowId ? null : { rowId, url }
                );
              }}
              style={{
                backgroundColor: isSelected ? "#ffe58f" : "",
                border: "none", // ⬅️ No border
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                boxShadow: isSelected ? "0 0 0 2px #d48806" : "none", // optional glow
                borderRadius: "6px", // optional round
              }}
            >
              <FileTextIcon />
            </Button>
          </Tooltip>
        );
      },
    },

    {
      title: "Unauthorized Changes",
      key: "unauthorized_changes",
      render: (text, record) => {
        const isDisabled = !record?.compare_file_url;

        return (
          <Tooltip title={isDisabled ? "No diff available" : "View unauthorized changes"}>
            <Button
              onClick={() => {
                if (!isDisabled) handleTrackChangeView(record.compare_file_url);
              }}
              disabled={isDisabled}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                opacity: isDisabled ? 0.2 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
                border: "none", // ⬅️ No border,
                boxShadow: "none" // optional glow
              }}
            >
              <EyeOutlineIcon />
            </Button>
          </Tooltip>
        );
      },
    }


  ];
  console.log(selectedPrev, selectedCurr, "selectedPrev, selectedCurr")

  let customFieldsValue = [];
  if (contract && contract.custom_field) {
    customFieldsValue = Object.keys(contract.custom_field)
      .filter((key) => key.includes("field"))
      .map((key) => ({
        field: key.includes("field") ? contract.custom_field[key] : "",
      }));
  }

  let customValues = [];
  if (contract && contract.custom_field) {
    customValues = Object.keys(contract.custom_field)
      .filter((key) => key.includes("value"))
      .map((key) => ({
        value: key.includes("value") ? contract.custom_field[key] : "",
      }));
  }

  const combinedCustomList = customFieldsValue.map((fieldObj, index) => ({
    field: fieldObj.field,
    value: customValues[index]?.value,
  }));

  const customTabColumns = [
    {
      title: "Particular",
      dataIndex: "field",
      render: (_, record, index) => (
        <>
          {productEditMode && editedContract ? (
            <Input
              name={"field"}
              // value={record.value}
              defaultValue={record.field}
              onChange={(e) =>
                handleCustomFormChange(e.target.value, index, e.target.name)
              }
            />
          ) : (
            <h1>{record.field}</h1>
          )}
        </>
      ),
    },

    {
      title: "Details",
      dataIndex: "value",
      render: (_, record, index) => (
        <>
          {productEditMode && editedContract ? (
            <Input
              name={"value"}
              // value={record.value}
              defaultValue={record?.value}
              onChange={(e) =>
                handleCustomFormChange(e.target.value, index, e.target.name)
              }
            />
          ) : (
            <h1>{record?.value}</h1>
          )}
        </>
      ),
    },
    ...(!productEditMode &&
      (!!role &&
        contract &&
        ((contract.editable_user &&
          contract.status !== "EXECUTED" &&
          contract.status !== "TRANSACTION_CLOSED" &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) &&
          ((role?.toLocaleLowerCase() === "agreement controller head") ||
            (role?.toLocaleLowerCase() === "agreement controller team"))) ||
          (contract.is_draft &&
            contract.created_by ===
            user_email)))
      ? [
        {
          title: "Delete Field",
          dataIndex: "age",
          key: "age",
          render: (_, record, index) => (
            <span>
              <Popconfirm
                title="Delete Custom Field"
                description="Are you sure to delete this Field?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => {
                  const fieldName = `field${index + 1}`;
                  const valueName = `value${index + 1}`;
                  delete updatedCustomForm[fieldName];
                  delete updatedCustomForm[valueName];
                  handleSave({ custom_field: updatedCustomForm })
                }
                }
              >
                <Button danger>
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </span>
          ),
        },
      ]
      : []),
  ];
  let contractUsersOption = [];
  if (contract && contract.contract_access_users) {
    const userEmail = user_email;
    contractUsersOption = contract.contract_access_users.reduce(
      (options, user) => {
        if (user.email !== userEmail) {
          options.push({
            value: user.id,
            label: `${user.first_name}  (${user.role})`,
          });
        }
        return options;
      },
      []
    );
  }
  const setTenureDate = (values) => `${values[0]} Years ${values[1]} Months ${values[2]} Days`;

  const handleOpenLinkedModal = () => {
    setIsLinkedModalVisible(true);
  };


  const handleSendReminder = async () => {
    console.log(pendingEmails)
    if (!pendingEmails || pendingEmails.length === 0) {
      message.warning("All recipients have already approved. No reminders sent");
      return;
    }

    setIsReminderLoading(true);

    try {
      const res = await axiosInstance.post("/send-esign-reminder/", {
        emails: pendingEmails,
        document_id: documentId,
      });
      message.success("Reminder sent successfully!");
    } catch (err) {
      console.error("Reminder error:", err);
      message.error("Failed to send reminder.");
    } finally {
      setIsReminderLoading(false);
    }
  };
  const showUserAddModal = () => {
    setIsUserAddModalVisible(true);
  };
  const handleOk = (type) => {
    if (type === 'Send Contract') {
      SendContractForm.submit();
    } else if (type === 'Counter Party') {
      CounterPartyForm.submit();
    } else if (type === 'Contract to Different User') {
      differentUserForm.submit();
    } else if (type === 'Add Custom Fields') {
      customFieldsForm.submit();
    } else if (type === 'Add User') {
      addUserForm.submit();
    } else if (type === 'Add Attachments') {
      addAttachmentsForm.submit();
    }
  };
  const handleModalCancel = () => {
    setIsUserAddModalVisible(false);
    setIsSendModalVisible(false);
    setModalVisible(false);
    setIsThirdPartyVisible(false);
    setIsDifferentUser(false);
    setAttachmentModal(false);
    setCustomModal(false);
    setMasterTempModal(false);
    setFormFields([{ id: 1, value: "" }]);
    setCustomFields([])
    SendContractForm.resetFields();
    CounterPartyForm.resetFields();
    differentUserForm.resetFields();
    customFieldsForm.resetFields();
    addUserForm.resetFields();
    addAttachmentsForm.resetFields();
  };
  const handleAddUserSubmit = (values) => {
    if (typeof values.user_email === 'string') {
      values.user_email = values.user_email.split(',');
    }
    if (!values.hasOwnProperty("assign")) {
      values.assign = true;
    }

    axiosInstance.put(`/contract/${params.pk}/assign/`, values)
      .then((response) => {
        // Handle successful response
        setEditMode(false);
        message.success(response.data.message);
        fetchContracts();
        addUserForm.resetFields();
        addAttachmentsForm.resetFields();
      })
      .catch((error) => { });

    setEditMode(false);
    setIsUserAddModalVisible(false);
  };
  const handleReceiversEmailChange = (values) => {
    // const selectedValues = Object.values(values).map((item) => item.value);
    // setSelectedEmails(selectedValues);
  };
  const selectedStatusOption = (value) => {
    setSelectedStatus(value);
  };
  const handleEdit = () => {
    setEditMode(true);
  };
  const handleProductEdit = () => {
    setProductEditMode(true);
  };
  const fetchState = async (value, type) => {
    try {
      const response = await axiosInstance.get("/state/get/", {
        customParams: {
          country_id: value,
        },
      });
      if (type === "all") {
        setStates(response.data); // Update the state with the fetched user data
      } else if (type === "client") {
        setClientStates(response.data);
      } else if (type === "party") {
        setPartyStates(response.data);
      }
    } catch (error) { }
  };
  const handleCancel = () => {
    updatedCustomForm = contract ? { ...contract.custom_field } : {};
    setEditMode(false);
    setProductEditMode(false);
  };
  const handleSave = (data) => {
    // Check the data being passed to the API;
    if (data?.custom_field) {
      const hasEmptyValues = Object.values(data.custom_field)?.some(value => !value.trim());
      if (hasEmptyValues) {
        message.error('Every field should be fill up in custom tab')
        return false;
      }
    }
    const tenure = setTenureDate([years, months, days]);
    const payload = data ? { ...data, tenure } : { ...newData, tenure };
    // Make the API call to update the contract
    axiosInstance.patch(`/contract/${params.pk}/update/`, { data: payload })
      .then((response) => {
        // Log the response from the API for debugging
        // editedContract
        // const updatedData = {...contract,...editedContract}
        // setContract({...updatedData})
        // Reset edit modes and related states
        setEditMode(false);
        setProductEditMode(false);
        setCustomFields([]);
        setCustomModal(false);
        customFieldsForm.resetFields();
        // Show success message
        message.success("Contract Updated Successfully");

        // Fetch updated contracts
        fetchContracts();
      })
      .catch((error) => {
        // Handle and log the error
        console.error("Error updating contract:", error.response?.data || error.message);

        // Reset edit modes and related states
        setProductEditMode(false);
        setEditMode(false);
        setCustomModal(false);
        setCustomFields([]);

        // Show error message
        message.error("An error occurred while updating the contract.");
      })
      .finally(() => {
        // Log finalization for debugging
        console.log("handleSave API call completed.");
      });
  };
  const handleCustomFieldChange = (index, field, value, id) => {
    const updatedFields = [...customFields];
    updatedFields[index] = { field, value, id };
    setCustomFields(updatedFields);
  };
  const handleAddCustomField = () => {
    setCustomFields([...customFields, { field: "", value: "", id: Date.now().toString(36) + Math.random().toString(36).substring(2, 5) }]);
  };
  const handleRemoveCustomField = (index) => {
    const updatedFields = [...customFields];
    updatedFields.splice(index, 1);
    setCustomFields(updatedFields);
    customFieldsForm.resetFields();
    const newValues = updatedFields.reduce((acc, field) => {
      acc[`field${field.id}`] = field.field;
      acc[`value${field.id}`] = field?.value;
      return acc;
    }, {});
    customFieldsForm.setFieldsValue(newValues);
  };
  const handleCustomFormChange = (value, index, name) => {
    const fieldName = `field${index + 1}`;
    const valueName = `value${index + 1}`;
    if (name === "field") {
      // Update field3 based on field index
      updatedCustomForm[fieldName] = value;
    } else if (name === "value") {
      // Update field3 based on value index
      updatedCustomForm[valueName] = value;
    }
  };
  const handleAddressChange = (e, addressType, select, type, multiData) => {
    const { name, value } = e.target;
    if (name === "country") {
      if (addressType === "client_address") {
        fetchState(value, "client");
      } else if (addressType === "party_address") {
        fetchState(value, "party");
      }
    }

    setEditedContract((prevAddress) => {
      // Initialize prevAddress if it's null or undefined
      if (!prevAddress) {
        return {
          [addressType]:
            select === "select" ? multiData ? multiData : { [type]: { id: value } } : { [name]: value },
        };
      }

      // Initialize prevAddress[addressType] if it's null or undefined
      let updatedAddressType = prevAddress[addressType]
        ? { ...prevAddress[addressType] }
        : {};

      // Initialize prevAddress[addressType][type] if it's null or undefined
      if (select === "select") {
        if (multiData) {
          updatedAddressType = { ...prevAddress[addressType], ...multiData };
        } else {
          updatedAddressType[type] =
            prevAddress[addressType] && prevAddress[addressType][type]
              ? { ...prevAddress[addressType][type], id: value }
              : { id: value };
        }

      } else {
        updatedAddressType[name] = value;
      }
      return {
        ...prevAddress,
        [addressType]: updatedAddressType,
      };
    });
  };
  const handleAgreementChange = (value, key) => {
    console.log({ value, key })
    setEditedContract((prevCompany) => ({
      ...prevCompany,
      [key]: value,
    }));
  };
  const sendEmailReminder = async (email) => {
    try {
      const response = await axiosInstance.post(`/send-reminder-mail/`, { "receiver": email, "agreement_id": contract?.id });
      message.success(response?.data?.message)

    } catch (error) {
      console.log(error)
      console.log(error?.data?.error)
      message.error("Failed To Send Email Reminder")
    }
  };
  const fetchContracts = async () => {
    try {
      const response = await axiosInstance.post(`/contract/${params.pk}/get/`, { id: params.pk });
      const getDataValue = parseDuration(response.data.tenure);
      setYears(getDataValue[1])
      setMonths(getDataValue[2])
      setDays(getDataValue[3])
      setContract(response.data);
      setEditedContract(response.data);
      console.log(response.data.document_id)
      setDocumentId(response.data.document_id)
    } catch (error) {
      setErrorinContractGet(error.response?.data?.error || "Failed to fetch contract details");
      console.log(error.response?.data?.error, "error in fetchContracts")
    }
  };
  const onVersionControlDownload = async (link) => {
    try {
      if (!link) {
        message.error('There have no file to download');
        return false;
      }
      console.log(link)
      await downloadFile(link, contract?.document_id)
    } catch (error) {
      console.log(error)
    }
  }
  const onEllipseDownload = async (link, name) => {
    const payload = {
      agreement_id: params.pk
    }
    try {
      if (!link) {
        message.error('Document dose not exits .');
        return;
      }
      await downloadFile(link, name, true);
      message.success('Download completed .')
    } catch (error) {
      console.log(error)
      message.error(error?.response?.data?.error)
    }
  }
  const handlePdfDownload = (agreeementPdf) => {
    if (agreeementPdf) {
      downloadFile(agreeementPdf, contract?.document_id)
      setErrorMessageShown(false);
    } else {
      if (!errorMessageShown) {
        message.error("Document does not exist.");
        setErrorMessageShown(true);
        setTimeout(() => {
          setErrorMessageShown(false);
        }, 5000);
      }
    }
  };
  const customRequest = ({ file, onSuccess, onError }) => {
    setFileUploading(true);
    // Custom logic to handle file upload
    const formData = new FormData();
    formData.append("agreement_file", file);
    formData.append("agreement_id", contract && contract.id);

    try {
      axiosInstance.post(`/contract/save_agreement_file/`, formData)
        .then((response) => {
          onSuccess(); // Trigger success callback
          message.success("Document Saved Successfully.");
          fetchContracts();
          setFileUploading(false);
        })
        .catch((error) => {
          onError(); // Trigger error callback
          message.error(error?.response?.data?.error.error);
          setFileUploading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const uploadFile = async ({ id, clause }) => {
    setMasterTempUploading(true);
    const formData = new FormData();
    formData.append("agreement_id", contract && contract.id);

    // Custom logic to handle different parameters
    if (id) {
      formData.append("master_template_id", id);
    }
    if (clause) {
      formData.append("clause_list", JSON.stringify(clause));
    }

    try {
      if (id) {
        setIsMasterLoading(true);
      }
      if (clause) {
        setIsClauseLoading(true);
      }
      const response = await axiosInstance.post(`/contract/save_agreement_file/`, formData)
      if (response.status === 200) {
        message.success("Document Saved Successfully.");
        setMasterTempUploading(false);
        setIsMasterLoading(false);
        setIsClauseLoading(false);
        setClauseTempModal(false);
        setMasterTempModal(false);
      } else {
        setMasterTempUploading(false);
        setMasterTempModal(false);
        setIsMasterLoading(false);
        setClauseTempModal(false);
        setIsClauseLoading(false);
      }

      return { data: response.data, res: response };
    } catch (error) {
      console.log(error);
      setMasterTempUploading(false);
      setIsLoading(false);
      setMasterTempUploading(false);
      setMasterTempModal(false);
      setClauseTempModal(false);
      setIsMasterLoading(false);
      setIsClauseLoading(false);
    }
  };
  const uploadMasterTemp = ({ id }) => {
    uploadFile({ id });
  };
  const handleClauseSubmit = (clause) => {
    uploadFile({ clause: clause });
  };
  const fetchTemplates = async () => {
    try {
      const response = await axiosInstance.get(`/contract/master-template/`)
      setTemplateData(response.data);
    } catch (error) { }
  };
  const fetchMasterTemplates = async () => {
    try {
      const response = await axiosInstance.get(`/contract/get-master-template/`)
      setMasterTemplateData(response.data);
    } catch (error) { }
  };
  const handleMasterTempButton = () => {
    setMasterTempModal(true);
  };
  const handleClauseTempButton = () => {
    setClauseTempModal(true);
  };
  const handleMasterTempCancelButton = () => {
    setMasterTempModal(false);
  };
  const handleClauseTempCancelButton = () => {
    setClauseTempModal(false);
  };
  const isEsignPenCom = (type, bod) => {
    warMdlType.current = type;
    warMdlBod.current = bod[contract.esign_status];
    return warMdlBod.current
  }
  const handleUploadClick = (e) => {
    e.stopPropagation(); // Stop default upload behavior
    e.preventDefault(); // Prevent file picker from opening immediately
    const param = {
      'pending': 'The Agreement has been forwarded for e-signature. Would you like to continue?',
      'completed': 'The Agreement has been signed by all the Parties. Would you like to continue?'
    }
    const isEsignStatus = isEsignPenCom('uploadFromLocal', param)
    if (isEsignStatus) {
      setModifyOpen(isEsignStatus);

      return isEsignStatus;
    } // Open confirmation modal

    uploadRef.current.upload.uploader.onClick();
  };
  const uploadContent = (
    <div>
      <div className="flex justify-center">
        <Upload
          customRequest={customRequest}
          showUploadList={false} // Hide the default file list
          ref={uploadRef}
        // openFileDialogOnClick={ false }
        >
          <Button
            icon={<UploadOutlined />}
            loading={fileUploading}
            className="menuButtton"
            onClick={handleUploadClick}
          >
            {fileUploading ? "Uploading" : "Upload from device"}
          </Button>
        </Upload>
      </div>
      <div>
        <Button
          icon={<UploadOutlined />}
          loading={isMasterLoading}
          className="menuButtton"
          onClick={() => {
            const param = {
              'pending': 'The Agreement has been forwarded for e-signature. Would you like to continue?',
              'completed': 'The Agreement has been signed by all the Parties. Would you like to continue?'
            }
            const isEsignStatus = isEsignPenCom('uploadFromMstTem', param)
            if (isEsignStatus) {
              setModifyOpen(isEsignStatus);

              return isEsignStatus;
            } // Open confirmation modal
            handleMasterTempButton()

          }}
        >
          {"Master Template"}
        </Button>
      </div>
      <div>
        <Button
          icon={<PictureOutlined />}
          loading={isClauseLoading}
          className="menuButtton"
          onClick={() => {
            const param = {
              'pending': 'The Agreement has been forwarded for e-signature. Would you like to continue?',
              'completed': 'The Agreement has been signed by all the Parties. Would you like to continue?'
            }
            const isEsignStatus = isEsignPenCom('uploadFromClause', param)
            if (isEsignStatus) {
              setModifyOpen(isEsignStatus);

              return isEsignStatus;
            } // Open confirmation modal
            handleClauseTempButton();

          }}
        >
          {"Clause"}
        </Button>
      </div>
    </div>
  );
  const openInNewTab = (params, agreementFile, agreementFileBeforeEsign) => {
    const getExtension = (url) => {
      return url?.split('.').pop()?.toLowerCase();
    };

    const agreementExt = getExtension(agreementFile);
    let fileToOpen = null;

    if (agreementExt === 'pdf') {
      // First time, signed PDF hai → open before_esign (original DOCX)
      fileToOpen = agreementFileBeforeEsign || agreementFile;
    } else {
      // DOCX hai → user ne edit kiya hoga → open updated DOCX
      fileToOpen = agreementFile;
    }

    if (!params || !fileToOpen) {
      if (!errorMessageShown) {
        message.error("Document does not exist.");
        setErrorMessageShown(true);
        setTimeout(() => {
          setErrorMessageShown(false);
        }, 5000);
      }
    } else {
      onOpenEditor(fileToOpen);
    }
  };
  const onOpenEditor = async (link) => {
    try {
      // const fileToOpen = await decryptByLink(link)
      const fileToOpen = link;
      // downloadFile(link)
      // const params = params.pk;
      const encodedFile = encodeURIComponent(fileToOpen);
      const timestamp = Date.now();
      window.open(`/edit-document/${params?.pk}?agreementFile=${encodedFile}&t=${timestamp}`, "_blank");
    } catch (error) {
      console.log(error)
    }
  }
  const handleSendButton = () => {
    setIsSendModalVisible(true);
  };
  const handleThirdPartyButton = () => {
    setIsThirdPartyVisible(true);
  };
  const handleDiffUserButton = () => {
    setIsDifferentUser(true);
  };
  const validateBeforeExecution = (contractData) => {
    const missingFields = [];
    console.log(contractData, "contractData")
    const {
      name_of_authorised_signatory_of_party,
      name_of_authorised_signatory_of_client,
      party_address,
      nature,
      agreement_type,
      effective_date,
      client_address,
      date_of_execution,
      jurisdiction,
      termination_notice,
      agreement_file,
      remarks,
    } = contractData;

    // if (!remarks) missingFields.push("Remarks of Agreement");
    if (!effective_date) missingFields.push("Effective Date");
    if (!date_of_execution) missingFields.push("Execution Date");
    if (!jurisdiction) missingFields.push("Jurisdiction of Agreement");
    if (!termination_notice) missingFields.push("termination Notice in Agreement Detail");
    if (!nature) missingFields.push("Nature of Agreement");
    if (!agreement_type) missingFields.push("Type of Agreement");
    if (!party_address?.state?.id) missingFields.push("Business Entity State");
    if (!party_address?.country?.id) missingFields.push("Business Entity Country");
    if (!party_address.postal_code) missingFields.push("Business Entity Postal Code");
    if (!party_address.city) missingFields.push("Business Entity City");
    if (!party_address.address2) missingFields.push("Business Entity Address - Line 2");
    if (!party_address.address1) missingFields.push("Business Entity Address - Line 1");
    if (!name_of_authorised_signatory_of_client) missingFields.push("Authorized Signatory Name of Business Entity");
    if (!client_address?.state?.id) missingFields.push("Business Partner State");
    if (!client_address?.country?.id) missingFields.push("Business Partner Country");
    if (!client_address.postal_code) missingFields.push("Business Partner Postal Code");
    if (!client_address.city) missingFields.push("Business Partner City");
    if (!client_address.address2) missingFields.push("Business Partner Address - Line 2");
    if (!client_address.address1) missingFields.push("Business Partner Address - Line 1");
    if (!name_of_authorised_signatory_of_party) missingFields.push("Authorized Signatory Name of Business Partner");
    if (!agreement_file) missingFields.push("Agreement File");

    return missingFields;
  };
  const handleSendSubmit = (values) => {
    if (values.status === "EXECUTED") {
      const missingFields = validateBeforeExecution(editedContract);
      if (missingFields.length > 0) {
        setIsSendModalVisible(false);
        missingFields.forEach((field) => message.error(`${field} is required`));
        return;
      }
    }


    const updatedValues = {
      ...values,
      agreement_id: contract && contract?.id,
    };
    axiosInstance.post(`/contract/send_agreement/`, updatedValues).then((response) => {
      message.success(response.data.message);
      setIsSendModalVisible(false);
      SendContractForm.resetFields();
      navigate("/admin/contracts/");
    })
      .catch((error) => {
        message.error(error?.response?.data?.error || error?.response?.data?.detail || "Failed To Send");
        setIsSendModalVisible(false);
        SendContractForm.resetFields();
      });
  };
  const assignDiffUser = (values) => {
    const updatedValues = {
      ...values,
      agreement_id: contract && contract.id,
    };
    axiosInstance.put(`/contract/assign-agreement-to-diff-user/`, updatedValues)
      .then((response) => {
        message.success(response.data.message);
        setIsDifferentUser(false);
        navigate(-1)        // backend team wants to redirect to pri page after successfull 
        differentUserForm.resetFields();
      })
      .catch((error) => {
        message.error("Some Error Occured.");
        setIsDifferentUser(false);
        differentUserForm.resetFields();
      });
  };
  const handleThirdPartySubmit = (values) => {
    const updatedValues = {
      ...values,
      agreement_id: contract && contract.id,
    };
    axiosInstance.post(`/contract/send-agreement-to-third-party/`, updatedValues)
      .then((response) => {
        message.success(response.data.message);
        setIsThirdPartyVisible(false);
        fetchContracts();
        CounterPartyForm.resetFields();
        navigate("/admin/contracts/");
      })
      .catch((error) => {
        message.error(error.response.data.error);
        setIsSendModalVisible(false);
        CounterPartyForm.resetFields();
      });
  };
  const handleSubmitSendToSelf = () => {
    const updatedValues = {
      receiver: [`${user_email}`],
      agreement_id: contract && contract.id,
      remark: "Sent to self",
    };
    axiosInstance.post(`/contract/send-agreement-to-third-party/`, updatedValues)
      .then((response) => {
        message.success(response.data.message);
        setIsThirdPartyVisible(false);
        fetchContracts();
        // form.resetFields();
        navigate("/admin/contracts/");
      })
      .catch((error) => {
        message.error(error.response.data.error);
        setIsSendModalVisible(false);
        // form.resetFields();
      });
  };
  const fetchCompanyUsers = async () => {
    try {
      const response = await axiosInstance.get(`/user/get_user_email/`, {
        customParams: {
          is_active: true,
        }
      })
      const existIds = contract.contract_access_users.map((item) => item.id)
      const newOptions = response.data.data.filter((item) => !existIds.includes(item.id)).map((item) => ({
        value: item.email, // Set the value to the email property
        label: `${item.first_name} (${item.role})`, // Set the label to a relevant property from your API data
      }));
      // contract.contract_access_users
      setCompanyUsers(newOptions);
      const newOptionsWithID = response.data.data.map((item) => ({
        value: item.id,
        // label: item.first_name, 
        label: `${item.first_name} ${item.role}`,
        // // Combine name and role for display
        // role: item.role, // Include role for further use if needed
      }));
      setCompanyDiffUsers(newOptionsWithID);
    } catch (error) { }
  };
  const fetchAgreementPdf = async (params) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get_agreement_summary/`, {
        customParams: {
          agreement_id: params
        }
      })
      if (response) {
        setIsLoading(false);
        // setAgreeementPdf(response.data.data);
        handlePdfDownload(response.data.data && response.data.data);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleEsignButton = async () => {
    setIsLoading(true);
    if (contract.agreement_file) {
      try {
        const response = await axiosInstance.post(`/esign/add_document/`, {
          agreement_id: contract.id,
          status: "UNDER_EXECUTION",
          remarks: "Send to Esign",
          agreement_file_edit_permission_user_id: contract.editable_user,
        });
        if (response?.data) {
          window.open(response.data.redirect_url, "_blank", "noreferrer");
          navigate("/admin/contracts");
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        // message.error(error.response);
      }
    }
  };
  const handleEmailChange = (value) => {
    // Handle the changes in email addresses
    console.log(value);
  };
  const isStatusExcuted = () => {
    return contract?.status === "EXECUTED" || contract?.status === "TRANSACTION_CLOSED";
  }
  const content = (
    <>
      <div className="flex flex-col">
        {role &&
          contract &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="menuButtton"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?"
                }
                const isEsignStatus = isEsignPenCom('sendOrganization', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleSendButton()
              }}
              icon={<MailOutlined />}
            >
              Send within organization
            </Button>
          </>
        ) : null}
        {role &&
          contract &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="menuButtton"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?",
                }
                const isEsignStatus = isEsignPenCom('counterParty', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleThirdPartyButton()
              }}
              icon={<SendOutlined />}
            >
              Send to Counter Party
            </Button>
          </>
        ) : null}
        {role &&
          contract &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="menuButtton"
              onClick={() => {

                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?",
                }
                const isEsignStatus = isEsignPenCom('sendSelf', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleSubmitSendToSelf()
              }}
              icon={<SendOutlined />}
            >
              Send to Self
            </Button>
          </>
        ) : null}
        {/* {role && contract?.agreement_file && contract.status !== "FRESH_REQUEST" && contract.status !== "UNDER_NEGOTIATION" ? ( */}
        {role && contract?.agreement_file &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="menuButtton"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?",
                  'completed': "The Agreement has been signed by all the Parties. Would you like to continue?"
                }
                const isEsignStatus = isEsignPenCom('Esign', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleEsignButton()
              }}
              icon={<FileTextOutlined />}
            >
              E-sign
            </Button>
          </>
        ) : null}

        {role &&
          contract &&
          // contract.editable_user &&
          // parseInt(user_id) ===
          // parseInt(contract.editable_user) 
          isStatusExcuted()
          ? (
            <>
              <Button
                className="menuButtton"
                onClick={() => {
                  setIsOpnSentAgreement(true)
                }}
                icon={<SendOutlined />}
              >
                Sent Agreement
              </Button>
            </>
          ) : null}

        {role &&
          contract &&
          contract.editable_user &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="menuButtton"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?"
                }
                const isEsignStatus = isEsignPenCom('otherUser', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleDiffUserButton()
              }}
              icon={<IdcardOutlined />}
            >
              Assign to Other User
            </Button>
          </>
        ) : null}
        <Button
          className="menuButtton"
          onClick={() => onEllipseDownload(contract.agreement_file, contract.document_id)}
          icon={<DownloadOutlined />}
        >
          Download Document
        </Button>
        {isStatusExcuted() ? (
          ""
        ) : (
          <>
            {contract &&
              parseInt(user_id) ===
              parseInt(contract.editable_user) ? (
              <Button
                className="menuButtton"
                onClick={() => {
                  setAgreementFileBeforeEsign(contract?.agreement_file_before_esign ?? null)
                  const agreementFile = contract?.agreement_file ?? null;
                  const param = {
                    'pending': "The Agreement has been forwarded for e-signature. Would you like to continue? ",
                    'completed': "The Agreement has been signed by all the Parties. Would you like to continue?"
                  }
                  const isEsignStatus = isEsignPenCom('modifyDoc', param)
                  if (isEsignStatus) {
                    setModifyOpen(isEsignStatus);

                    return isEsignStatus;
                  } else if (agreementFile) {
                    // If agreement file is available, open directly
                    openInNewTab(contract.id, agreementFile, agreementFileBeforeEsign);
                  } else {
                    message.info('You do not have agreement .')
                    console.error("No agreement file available to open.");
                  }
                }}
                icon={<HighlightOutlined />}
              >
                Modify Document
              </Button>


            ) : (
              ""
            )}
          </>
        )}

        {(role &&
          contract &&
          role === "admin" &&
          contract.status === "EXECUTED" &&
          contract.is_created_from_bulk_upload &&
          !contract.is_agreement_file_uploaded) ||
          (role &&
            contract &&
            contract.editable_user &&
            !isStatusExcuted() &&
            parseInt(user_id) ===
            parseInt(contract.editable_user)) ? (
          <>
            {role && (role === "agreement controller head" || role === "agreement controller team") ? (
              <>
                <Popover
                  content={uploadContent}
                  title=""
                  trigger="hover"
                  placement="bottom"
                >
                  <Button>Upload</Button>
                </Popover>
              </>
            ) : (
              <div className="flex justify-center">
                <Upload
                  customRequest={customRequest}
                  showUploadList={false} // Hide the default file list
                >
                  <Button
                    icon={<UploadOutlined />}
                    loading={fileUploading}
                    className="menuButtton"
                  >
                    {fileUploading ? "Uploading" : "Upload Document"}
                  </Button>
                </Upload>
              </div>
            )}
          </>
        ) : null}
        <div className="flex justify-center"></div>
      </div>
    </>
  );
  const handleNext = () => {
    if (editMode || productEditMode) {
      if (canShowErrorMessage) {
        message.error("Please save/cancel form first.");
        canShowErrorMessage = false;
        setTimeout(() => {
          canShowErrorMessage = true;
        }, 2000);
      }
      setActiveTab(activeTab);
    } else {
      Promise.all([
        SendContractForm.validateFields(),
        CounterPartyForm.validateFields(),
        differentUserForm.validateFields(),
        customFieldsForm.validateFields(),
        addUserForm.validateFields(),
        addAttachmentsForm.validateFields()
      ]).then(() => {
        const nextTab = (parseInt(activeTab, 10) % finalPage) + 1;
        const nextTabStr = nextTab.toString();
        setActiveTab(nextTabStr);

        const newParams = new URLSearchParams(location.search);
        newParams.set("tab", nextTabStr);
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
      });
    }
  };
  const handlePrevious = () => {
    if (editMode || productEditMode) {
      if (canShowErrorMessage) {
        message.error("Please save/cancel form first.");
        canShowErrorMessage = false;
        setTimeout(() => {
          canShowErrorMessage = true;
        }, 2000);
      }
      setActiveTab(activeTab);
    } else {
      const previousTab = ((parseInt(activeTab, 10) - 2 + finalPage) % finalPage) + 1;
      const previousTabStr = previousTab.toString();
      setActiveTab(previousTabStr);

      const newParams = new URLSearchParams(location.search);
      newParams.set("tab", previousTabStr);
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    }
  };

  const handleTabChange = (key) => {
    if (editMode || productEditMode) {
      if (canShowErrorMessage) {
        message.error("Please save/cancel form first.");
        canShowErrorMessage = false;
        setTimeout(() => {
          canShowErrorMessage = true;
        }, 2000);
      }
      setActiveTab(activeTab);
    } else {
      setActiveTab(key);

      // Update the URL to persist tab selection
      const newParams = new URLSearchParams(location.search);
      newParams.set("tab", key);
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    }
  };

  const getAttachments = async () => {
    try {
      const response = await axiosInstance.get(`/contract/attachment/`, {
        customParams: {
          agreement_id: params.pk,
        }
      })
      if (response) {
        setAttachments(response.data);
      }
    } catch (error) {
      console.error(error)
    }
  };
  const handleAttachemntClick = () => {
    setAttachmentModal(true);
  };
  const handleAddForm = () => {
    if (formFields.length < 5) {
      const newForm = { id: formFields.length + 1, value: "" };
      setFormFields([...formFields, newForm]);
    } else {
      // Optionally, you can provide feedback to the user that they can't add more forms
      message.error("You can only add upto 5 fields.");
    }
  };
  const handleRemoveForm = (id) => {
    if (formFields.length > 1) {
      const updatedFormFields = formFields.filter((field) => field.id !== id);
      setFormFields(updatedFormFields);
    }
  };
  const handleAttachmentSave = async () => {
    setUploading(true);
    await addAttachmentsForm.validateFields();
    const values = await addAttachmentsForm.getFieldsValue();
    // You can perform further actions with the saved attachment here
    const payload = {
      ...values,
      agreement_id: contract && contract.id,
      attachment: fileName && fileName,
    };
    const formData = convertIntoFormData(payload);

    axiosInstance.post(`/contract/attachment/`, formData).then((response) => {
      message.success("Document Saved Successfully.");
      setFormFields([{ id: 1, value: "" }]);
      fetchContracts();
      getAttachments(contract && contract.id);
      setAttachmentModal(false);
      setUploading(false);
      addAttachmentsForm.resetFields();
      setFilename();
    })
      .catch((error) => {
        message.error(error.response.data.error);
        setFormFields([{ id: 1, value: "" }]);
        setAttachmentModal(false);
        setUploading(false);
        addAttachmentsForm.resetFields();
        setFilename();
      });
  };
  const handleCustomFieldSave = async () => {
    try {
      await customFieldsForm.validateFields();
      const data = customFields.reduce((acc, item, index) => {
        const fieldIndex = index + findMaxIndex(contract && contract.custom_field);
        return acc = { ...acc, [`field${fieldIndex + 1}`]: item?.field, [`value${fieldIndex + 1}`]: item?.value }
      }, {})
      let payload = {};
      payload = { ...contract.custom_field, ...data };
      if (!Object.values(data).length) {
        throw new Error("Add at least one custom field");
      }
      handleSave({ custom_field: payload });
    } catch (error) {
      message.error(error.message || 'Form is invalid!');
    }
  };
  const fetchClauses = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/clause/`)
      setIsLoading(false);
      setClausesData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const fetchMasterClause = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get-master-clause/`);
      setIsLoading(false);
      setMasterClausesData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleSequenceChange = (id, sequence) => {
    setClausesData(
      clausesData.map((item) => {
        if (item.id === id) {
          return { ...item, sequence };
        }
        return item;
      })
    );
  };
  const handleEsignStatus = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(`/esign/get_document_status/`, { agreement_id: contract.id })
      if (response && response?.data) {
        const tempResponse = response?.data;
        const recipients = () => {
          const tempArr = tempResponse.recepients.map((recipient) => {
            return {
              fullName: recipient.FullName,
              email: recipient.EmailAddress,
              signatureImage: recipient.SignatureUpload,
              status: recipient.StatusCode,
            };
          });
          return tempArr;
        };

        setSignuluResponse({
          recepients: recipients(),
          addComments: tempResponse.addComments,
          senderName: tempResponse.senderName,
          statusCode: tempResponse.statusCode,
          expirationDate: tempResponse.expirationDate,
          fileName: tempResponse.uploadDocuments[0]?.FileName,
        });
        setEsignDetailModalOpen(true);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      message.error(error?.response?.data?.error);
    }
  };
  const handleEsignDocDownload = async () => {
    setIsLoading(true);
    try {
      // 1️⃣ Get the file URL from the API
      const response = await axiosInstance.post(`/esign/download_document/`, { agreement_id: contract.id });
      const fileUrl = response?.data?.document_url;

      if (!fileUrl) throw new Error("No document URL returned");

      // 2️⃣ Fetch the actual file using the returned URL
      const fileResponse = await fetch(fileUrl);
      if (!fileResponse.ok) {
        throw new Error(`Failed to download file. Status: ${fileResponse.status}`);
      }

      // 3️⃣ Create a blob from the response
      const blob = await fileResponse.blob();
      const objectURL = URL.createObjectURL(blob);

      // 4️⃣ Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = objectURL;
      link.download = 'e-sign-document.pdf';
      document.body.appendChild(link);
      link.click();

      // 5️⃣ Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(objectURL);
      fetchContracts();
      message.success("File downloaded successfully.");
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.error || "Error in downloading");
    } finally {
      setIsLoading(false);
    }
  };
  let customDFieldsCount = 0;
  if (contract && contract.custom_field) {
    customDFieldsCount = contract && Object.keys(contract.custom_field).length; // Get the number of keys in custom_field
  }
  if (fileUploading) {
    message.loading("File Uploading from Device ...", 0)
  }
  if (isClauseLoading) {
    message.loading("File Uploading from Clause ...", 0)
  }
  if (isMasterLoading) {
    message.loading("File Uploading from Master Templete...", 0)
  }


  useEffect(() => {
    if (signuluResponse?.recepients) {
      console.log(signuluResponse?.recepients)
      const emailsToRemind = signuluResponse.recepients
        .filter(r => r.status?.toUpperCase() === "SENT")
        .map(r => r.email);
      console.log(emailsToRemind, "emailsToRemind")
      setPendingEmails(emailsToRemind);
    }
  }, [signuluResponse]);

  useEffect(() => {
    if (clauseTempModal) {
      fetchMasterClause();
      fetchClauses();
    }
  }, [clauseTempModal]);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // User came back to the tab
        fetchContracts(); // Refresh the document details
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  useEffect(() => {

    if (contract && contract.id) {
      getAttachments(contract && contract.id);
    }
  }, [contract]);
  useEffect(() => {
    if (tab === 'versionControl') {
      setActiveTab("3");
    }
  }, [tab])
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axiosInstance.get(`/country/get/`)
        setCountries(response.data); // Update the state with the fetched user data
      } catch (error) {
        console.error(error)
      }
    };
    fetchCountry();
  }, []);
  useEffect(() => {
    fetchContracts();
  }, []);
  useEffect(() => {
    if (
      contract &&
      contract.client_address &&
      contract.client_address.country &&
      contract.client_address.country.id
    ) {
      fetchState(contract.client_address.country.id, "client");
      // fetchState(contract.party_address.country.id, 'party');
    }
    if (
      contract &&
      contract.party_address &&
      contract.party_address.country &&
      contract.party_address.country.id
    ) {
      fetchState(contract.party_address.country.id, "party");
      // fetchState(contract.party_address.country.id, 'party');
    }
  }, [contract]);
  useEffect(() => {
    fetchCompanyUsers();
  }, [contract]);
  useEffect(() => {
    if (!fileUploading && !isClauseLoading && !isMasterLoading) {
      fetchContracts();
    }
  }, [fileUploading, isClauseLoading, isMasterLoading]);
  useEffect(() => {
    fetchMasterTemplates();
    fetchTemplates();
  }, []);

  useEffect(() => {
    if (params.pk) {
      fetchContracts(params.pk); // ✅ API call here
    }
  }, [params.pk]);

  const attchmentsColumns = [
    {
      title: "Sender",
      dataIndex: "sender_name",
      render: (_, record) => record.third_party_sender_name || record.sender_name
    },
    {
      title: "Stage",
      dataIndex: "agreement_stage",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
    {
      title: "Brief particulatrs",
      dataIndex: "brief_particulars",
    },
    {
      title: "Download Document",
      dataIndex: "attachment",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => handlePdfDownload(record.attachment)}
          >
            <DownloadOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    console.log("Compare Mode:", compareMode);
  }, [compareMode]);

  if (errorinContractGet) {
    return (
      <div className="flex justify-center items-center h-[70%]">

        <Result
          status="403"
          title="Failed to fetch contract details"
          subTitle={errorinContractGet || "Agreement not found. Please try again later."}
          extra={<Button type="primary" onClick={() => navigate(-1)}>Go Back</Button>}
        />
      </div>
    );
  }



  return (
    <>
      <Modal
        title="Warning"
        open={dateModalVisible}
        onOk={() => setDateModalVisible(false)}
        onCancel={() => setDateModalVisible(false)}
        okText="Yes"
        cancelText="No"
      >
        You have selected a future date as Execution Date. Press ‘Yes’ if you
        intend to proceed with the selected future date.
      </Modal>
      <Modal
        title="Linked Agreements"
        open={isLinkedModalVisible}
        footer={null}
        onCancel={() => setIsLinkedModalVisible(false)}
      >
        {contract?.linked_expired_agreements?.map((item) => (
          <div
            key={item.linked_agreement_id}
            className="cursor-pointer mb-2 flex justify-between items-center my-5"
            onClick={() => {
              setIsLinkedModalVisible(false);
              navigate(`/admin/contracts/${item.linked_agreement_id}`);
            }}
          >
            <div>

              {item.linked_document_id}
            </div>
            <ExportOutlined
              className="text-blue-600 cursor-pointer"
              onClick={() => {
                setIsLinkedModalVisible(false);
                navigate(`/admin/contracts/${item.linked_agreement_id}`);
              }}
            />
          </div>
        ))}
      </Modal>

      {contract ? (
        <>
          <div className="flex flex-row justify-between items-center h-full">
            <ArrowLeftOutlined size={32} onClick={() => {
              location.state ? navigate(pathname, { state: location.state }) : navigate(-1);
            }} />
            <div className="ml-2">
              {!editMode && (
                <Popover
                  placement="left"
                  title={""}
                  content={content}
                  // trigger="click"
                  className="h-[3rem]"
                >
                  <Button>
                    <MoreOutlined />
                  </Button>
                </Popover>
              )}
              <Modal
                title="Send Contract"
                open={isSendModalVisible}
                onOk={() => { handleOk('Send Contract') }}
                onCancel={handleModalCancel}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Send"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={SendContractForm} onFinish={handleSendSubmit}>
                  <h1 className="font-lg">Please select the status</h1>
                  <Form.Item name="status" className="pt-1">
                    <Select
                      options={statusOptions}
                      onChange={selectedStatusOption}
                    ></Select>
                  </Form.Item>

                  {selectedStatus &&
                    (selectedStatus === "EXECUTED" ||
                      selectedStatus === "TRANSACTION_CLOSED") ? (
                    ""
                  ) : (
                    <>
                      <h1 className="font-lg">Edit right</h1>
                      <Form.Item
                        name="agreement_file_edit_permission_user_id"
                        className="pt-1"
                      >
                        <Select
                          options={contractUsersOption && contractUsersOption}
                        ></Select>
                      </Form.Item>
                    </>
                  )}

                  <h1 className="font-lg">Remark</h1>
                  <Form.Item
                    name="remarks"
                    className="pt-1"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a value.",
                      },
                    ]}
                  >
                    <TextArea />
                  </Form.Item>
                </Form>
              </Modal>
              <Modal
                title="Send Contract to Counter Party"
                open={isThirdPartyVisible}
                onOk={() => { handleOk('Counter Party') }}
                onCancel={handleModalCancel}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Send"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={CounterPartyForm} onFinish={handleThirdPartySubmit}>
                  <h1 className="font-lg">Receiver's Email</h1>
                  <Form.Item name="receiver" className="pt-1">
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Enter receiver's email"
                      onChange={handleEmailChange}
                      required
                    ></Select>
                  </Form.Item>
                  <h1 className="font-lg">Remark</h1>

                  <Form.Item name="remark" className="pt-1">
                    <TextArea required />
                  </Form.Item>
                </Form>
              </Modal>
              <Modal
                title="Are you sure?"
                open={isModifyOpen}
                onOk={() => {
                  // Ensure only valid users can modify
                  const currentUserId = parseInt(user_id);
                  const editableUser = parseInt(contract?.editable_user);

                  if (warMdlType.current === 'sendOrganization') {
                    handleSendButton()
                  } else if (warMdlType.current === 'counterParty') {
                    handleThirdPartyButton()
                  } else if (warMdlType.current === 'sendSelf') {
                    handleSubmitSendToSelf()
                  } else if (warMdlType.current === 'Esign') {
                    handleEsignButton()
                  } else if (warMdlType.current === 'otherUser') {
                    handleDiffUserButton()
                  } else if (warMdlType.current === 'modifyDoc') {

                    if (currentUserId === editableUser) {
                      openInNewTab(
                        contract?.id,
                        contract?.agreement_file, contract?.agreement_file_before_esign
                      );
                    } else {
                      console.error("Modification not allowed for this user.");
                    }

                  } else if (warMdlType.current === 'uploadFromLocal') {
                    uploadRef.current.upload.uploader.onClick();
                  } else if (warMdlType.current === 'uploadFromClause') {
                    handleClauseTempButton();
                  } else if (warMdlType.current === 'uploadFromMstTem') {
                    handleMasterTempButton();
                  }
                  setModifyOpen(false);
                }}
                onCancel={() => setModifyOpen(false)}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Yes"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }}
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }}
              >
                <h1>
                  {warMdlBod.current}
                </h1>
              </Modal>
              <SentAgreementModel isOpen={isOpnSentAgreement} onClose={() => { setIsOpnSentAgreement(false) }} agreement_id={contract?.id} />

              <Modal
                title="Assign Contract to Different User"
                open={isDifferentUser}
                onOk={() => { handleOk('Contract to Different User') }}
                onCancel={handleModalCancel}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Send"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={differentUserForm} initialValues={{ user_id: null }} onFinish={assignDiffUser}>
                  <Form.Item
                    name="user_id"
                    className="pt-1"
                    rules={[{ required: true, message: "Please select a user!" }]}
                  >
                    <Select
                      value={differentUserForm.getFieldValue("user_id")} // Ensure correct value binding
                      options={companyDiffUsers
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((user) => ({
                          value: user?.value,
                          label: `${user.label}`,
                        }))}
                      onChange={(value) => differentUserForm.setFieldsValue({ user_id: value })} // Update on change
                    />
                  </Form.Item>
                </Form>

              </Modal>
              <MasterTemplateModal
                visible={masterTempModal}
                onCancel={handleMasterTempCancelButton}
                onSelect={uploadMasterTemp}
                data={templateData}
                masterTempData={masterTemplateData}
                okText="Upload"
                loading={masterTempUploading}
              />
              <ClausesModal
                visible={clauseTempModal}
                onCancel={handleClauseTempCancelButton}
                clausesData={clausesData}
                masterClausesData={masterClausesData}
                handleSequenceChange={handleSequenceChange}
                onSubmit={handleClauseSubmit}
                // directSubmit={true}
                loading={isLoading}
              />
            </div>
          </div>
          <div style={{ height: '100%', minHeight: '600px', overflow: 'auto' }}>
            {isLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: 10,
                  backgroundColor: 'rgba(255,255,255,0.6)',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Spin tip="Loading..." size="large" />
              </div>
            )}
            <Tabs
              activeKey={activeTab}
              onChange={handleTabChange}
              type="card"
              animated={false}
              destroyInactiveTabPane={false}
              tabBarStyle={{ marginBottom: 0 }}
              style={{ flex: 1 }}
            >
              <TabPane forceRender tab="Business Detail" key="1">
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="text-black mt-6 pb-5 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
                    <span className="flex flex-row justify-center text-center items-center">
                      <h1 className="mr-4 text-3xl font-bold font-inter">
                        Business Partner
                      </h1>
                      {role &&
                        contract &&
                        ((contract.editable_user &&
                          contract.status !== "EXECUTED" &&
                          contract.status !== "TRANSACTION_CLOSED" &&
                          parseInt(user_id) ===
                          parseInt(contract.editable_user) &&
                          ((role?.toLocaleLowerCase() === "agreement controller head") ||
                            (role?.toLocaleLowerCase() === "agreement controller team"))) ||
                          (contract.is_draft &&
                            contract.created_by ===
                            user_email)) ? (
                        <>
                          {!editMode && editedContract && (
                            <div className="edit-icon">
                              <EditOutlined
                                onClick={handleEdit}
                                className="h-4 ml-2 text-lg transform scale-125"
                              />
                            </div>
                          )}
                        </>
                      ) : null}
                    </span>
                    {editMode && editedContract ? (
                      <div className="flex justify-between">
                        <div className="flex">
                          <ButtonComp
                            width="7em"
                            text={"Cancel"}
                            onClick={handleCancel}
                            margin={"4px"}
                            textColor="#4E36A3"
                          ></ButtonComp>
                          <ButtonComp
                            width="7em"
                            type="primary"
                            onClick={() => handleSave(newData)}
                            className=""
                            text={"Save"}
                            textColor="white"
                            bgColor="#4E36A3"
                          ></ButtonComp>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <Descriptions
                    title=""
                    layout="vertical"
                    bordered
                    className="responsive-descriptions agreement-detail"
                  >
                    {/* <Descriptions.Item label="Name">
                    {contract.name_of_client}
                  </Descriptions.Item> */}
                    <Descriptions.Item
                      label="Name"
                      span={1}
                    >
                      {editMode && editedContract ? (
                        <Input
                          name="name_of_client"
                          value={
                            editedContract.name_of_client
                          }

                          onChange={(e) => { setEditedContract({ ...editedContract, name_of_client: e.target.value }) }}
                        />
                      ) : (
                        <Descriptions.Item label="Name">
                          {contract.name_of_client}
                        </Descriptions.Item>
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Authorized Signatory’s Name of Business Partner"
                      span={2}
                    >
                      {editMode && editedContract ? (
                        <Input
                          name="name_of_authorised_signatory_of_party"
                          value={
                            editedContract.name_of_authorised_signatory_of_party
                          }

                          onChange={(e) => { setEditedContract({ ...editedContract, name_of_authorised_signatory_of_party: e.target.value }) }}
                        />
                      ) : (
                        contract.name_of_authorised_signatory_of_party
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Address Line 1" span={1}>
                      {editMode && editedContract ? (
                        <Input
                          name="address1"
                          defaultValue={
                            editedContract &&
                            editedContract.client_address &&
                            editedContract.client_address.address1
                          }
                          // onChange={handleAdress1Change}
                          onChange={(e) =>
                            handleAddressChange(e, "client_address")
                          }
                          required
                        />
                      ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.address1
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address Line 2" span={1}>
                      {editMode && editedContract ? (
                        <Input
                          name="address2"
                          defaultValue={
                            editedContract &&
                            editedContract.client_address &&
                            editedContract.client_address.address2
                          }
                          // onChange={handleAddress2Change}
                          onChange={(e) =>
                            handleAddressChange(e, "client_address")
                          }
                        />
                      ) : (
                        contract.client_address &&
                        contract.client_address.address2
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="City">
                      {editMode && editedContract ? (
                        <Input
                          name="city"
                          defaultValue={
                            editedContract &&
                            editedContract.client_address &&
                            editedContract.client_address.city
                          }
                          // onChange={handleCityChange}
                          onChange={(e) =>
                            handleAddressChange(e, "client_address")
                          }
                        />
                      ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.city
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="PIN">
                      {editMode && editedContract ? (
                        <Input
                          name="postal_code"
                          defaultValue={
                            editedContract &&
                            editedContract.client_address &&
                            editedContract.client_address.postal_code
                          }
                          // onChange={handleAddressChange}
                          onChange={(e) =>
                            handleAddressChange(e, "client_address")
                          }
                        />
                      ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.postal_code
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Country">
                      {editMode && editedContract ? (
                        <Select
                          defaultValue={editedContract?.client_address?.country?.id}
                          // onChange={handleClientCountryChange}
                          onChange={(value) => {
                            fetchState(value, "client");
                            setEditedContract({ ...editedContract, client_address: { ...editedContract.client_address, country: { id: value }, state: null } })
                          }
                          }
                          style={{ width: "100%" }} // Set the width of the Select component
                          dropdownStyle={dropdownStyle} //
                          autoWidth
                        >
                          {countries &&
                            countries.map((country) => (
                              <Select.Option key={country.id} value={country.id}>
                                {country.name}
                              </Select.Option>
                            ))}
                        </Select>
                      ) : (

                        contract?.client_address?.country?.name
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="State">
                      {editMode && editedContract ? (
                        <Select
                          defaultValue={contract?.client_address?.state?.id}
                          value={editedContract?.client_address?.state?.id}
                          onChange={(value) =>
                            handleAddressChange(
                              { target: { name: "state", value } },
                              "client_address",
                              "select",
                              "state"
                            )
                          }
                          autoWidth
                          style={{ width: "100%" }} // Set the width of the Select component
                        >
                          {clientStates &&
                            clientStates.map((state) => (
                              <Select.Option key={state.id} value={state.id}>
                                {state.name}
                              </Select.Option>
                            ))}
                        </Select>
                      ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.state &&
                        contract.client_address.state.name
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                  <h1 className="mr-4 mt-6 text-3xl font-bold font-inter">
                    Business Entity
                  </h1>
                  <Descriptions
                    title=""
                    layout="vertical"
                    bordered
                    className="mt-4 responsive-descriptions agreement-detail"
                  >
                    <Descriptions.Item
                      label="Name"
                      span={2}
                    >
                      {editMode && editedContract ? (
                        <Input
                          name="party"
                          value={
                            editedContract.party
                          }
                          onChange={(e) => { setEditedContract({ ...editedContract, party: e.target.value }) }}
                        />
                      ) : (
                        contract.party
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Authorized Signatory’s Name of Business Entity"
                      span={2}
                    >
                      {editMode && editedContract ? (
                        <Input
                          name="name_of_authorised_signatory_of_client"
                          value={
                            editedContract.name_of_authorised_signatory_of_client
                          }
                          onChange={(e) => { setEditedContract({ ...editedContract, name_of_authorised_signatory_of_client: e.target.value }) }}
                        />
                      ) : (
                        contract.name_of_authorised_signatory_of_client
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address Line 1" span={1}>
                      {editMode && editedContract ? (
                        <Input
                          name="address1"
                          defaultValue={
                            editedContract &&
                            editedContract.party_address &&
                            editedContract.party_address.address1
                          }
                          // onChange={handleAdressChange}
                          // onChange={handlePinChange}
                          onChange={(e) =>
                            handleAddressChange(e, "party_address")
                          }
                        />
                      ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.address1
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address Line 2" span={1}>
                      {editMode && editedContract ? (
                        <Input
                          name="address2"
                          defaultValue={
                            editedContract &&
                            editedContract.party_address &&
                            editedContract.party_address.address2
                          }
                          // onChange={handleAddress2Change}
                          onChange={(e) =>
                            handleAddressChange(e, "party_address")
                          }
                        />
                      ) : (
                        contract.party_address && contract.party_address.address2
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="City" span={1}>
                      {editMode && editedContract ? (
                        <Input
                          name="city"
                          defaultValue={
                            editedContract &&
                            editedContract.party_address &&
                            editedContract.party_address.city
                          }
                          // onChange={handlPartyCityChange}
                          onChange={(e) =>
                            handleAddressChange(e, "party_address")
                          }
                        />
                      ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.city
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="PIN" span={1}>
                      {editMode && editedContract ? (
                        <Input
                          name="postal_code"
                          defaultValue={
                            editedContract &&
                            editedContract.party_address &&
                            editedContract.party_address.postal_code
                          }
                          // onChange={handleAddressChange}
                          onChange={(e) =>
                            handleAddressChange(e, "party_address")
                          }
                        />
                      ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.postal_code
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Country" span={1}>
                      {editMode && editedContract ? (
                        <Select

                          defaultValue={
                            contract &&
                            contract.party_address &&
                            contract.party_address.country &&
                            contract.party_address.country.id
                          }
                          onChange={(value) => {
                            fetchState(value, "party");
                            setEditedContract({ ...editedContract, party_address: { ...editedContract.party_address, country: { id: value }, state: null } })
                          }
                          }
                          autoWidth
                          style={{ width: "100%" }}
                        >
                          {countries &&
                            countries.map((country) => (
                              <Select.Option key={country.id} value={country.id}>
                                {country.name}
                              </Select.Option>
                            ))}
                        </Select>
                      ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.country &&
                        contract.party_address.country.name
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="State" span={1}>
                      {editMode && editedContract ? (
                        <Select
                          name='state'
                          defaultValue={
                            contract &&
                            contract.party_address &&
                            contract.party_address.state &&
                            contract.party_address.state.id
                          }
                          // onChange={handlePartyStateChange}
                          onChange={(value) =>
                            handleAddressChange(
                              { target: { name: "state", value } },
                              "party_address",
                              "select",
                              "state"
                            )
                          }
                          autoWidth
                          style={{ width: "100%" }}
                        >
                          {partyStates &&
                            partyStates.map((state) => (
                              <Select.Option key={state.id} value={state.id}>
                                {state.name}
                              </Select.Option>
                            ))}
                        </Select>
                      ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.state &&
                        contract.party_address.state.name
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                  {contract && (
                    <Tooltip title={"Download Ageement Details"}>
                      <FloatButton
                        onClick={() => fetchAgreementPdf(contract.id)}
                        icon={isLoading ? <Spin /> : <DownloadOutlined />}
                        description=""
                        shape="square"
                        style={{
                          right: 120,
                          width: "6em",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      />
                    </Tooltip>
                  )}

                  <div className="text-black mt-6 pb-5 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
                    <div className="agreement-details">
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Agreement Details
                      </h1>
                    </div>
                  </div>
                  <Descriptions
                    title=""
                    layout="vertical"
                    bordered
                    className="agreement-detail"
                  >
                    <Descriptions.Item label="Agreement Type" span={1}>
                      {editMode && editedContract ? (<>


                        <Form.Item
                          // label="Agreement"
                          name="agreement_type"
                          rules={[
                            {
                              required: true,
                              message: "Please Select Ageement Type",
                            },
                          ]}
                        >
                          <AutoComplete
                            options={agreementOptions.map((option) => ({
                              value: option.value,
                            }))}
                            filterOption={(inputValue, option) =>
                              option.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            placeholder="Select or type to add agreement"
                            onChange={(val) => handleAgreementChange(val, 'agreement_type')}
                            defaultValue={contract?.agreement_type}
                          />
                        </Form.Item>
                      </>
                      ) : (
                        contract && contract.agreement_type
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Nature">
                      {editMode && editedContract ? (
                        <Form.Item
                          // label="Agreement"
                          name="agreement_type"
                          rules={[
                            {
                              required: true,
                              message: "Please Select Ageement Type",
                            },
                          ]}
                        >
                          <AutoComplete
                            options={natureOptions.map((option) => ({
                              value: option.value,
                            }))}
                            filterOption={(inputValue, option) =>
                              option.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            onChange={(val) => handleAgreementChange(val, 'nature')}
                            placeholder="Select or type to add nature"
                            defaultValue={contract && contract.nature}
                          />
                        </Form.Item>
                      ) : (
                        contract && contract.nature
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Tenure">
                      {editMode && editedContract ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row", // Change from "row" to "column"
                            alignItems: "center",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className="tenure-input-text">
                            <InputNumber
                              min={0}
                              size="large"
                              value={years}
                              onChange={(e) => { setYears(e) }}
                              placeholder="Years"
                            />
                          </span>
                          <span className="tenure-input-text">
                            <InputNumber
                              min={0}
                              size="large"
                              value={months}
                              onChange={(e) => { setMonths(e) }}
                              placeholder="Months"
                            />
                          </span>
                          <span className="tenure-input-text">
                            <InputNumber
                              min={0}
                              size="large"
                              value={days}
                              onChange={(e) => { setDays(e) }}
                              placeholder="Days"
                            />
                          </span>
                        </div>

                      ) : (
                        contract.tenure
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Termination Notice">
                      {editMode && editedContract ? (
                        <Input
                          name="termination_notice"
                          value={editedContract.termination_notice}
                          onChange={(e) => handleAgreementChange(e.target.value, 'termination_notice')}
                        />
                      ) : (
                        contract.termination_notice
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Jurisdiction">
                      {editMode && editedContract ? (
                        <Input
                          name="jurisdiction"
                          value={editedContract.jurisdiction}
                          onChange={(e) => handleAgreementChange(e.target.value, 'jurisdiction')}


                        />
                      ) : (
                        contract.jurisdiction
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Execution Date" span={1}>
                      {editMode && editedContract ? (
                        <DatePicker
                          name="date_of_execution"
                          style={{ width: "100%" }}
                          format="DD-MM-YYYY"
                          defaultValue={
                            contract.date_of_execution
                              ? dayjs(
                                dayjs(
                                  contract.date_of_execution,
                                  "YYYY-MM-DD"
                                ).format("DD-MM-YYYY"),
                                dateFormat
                              )
                              : null
                          }
                          onChange={(date) => {
                            if (!date) return;

                            const selectedDate = dayjs(date);
                            const today = dayjs().startOf("day");

                            setExecutionDate(selectedDate.format("YYYY-MM-DDTHH:mm:ss"));

                            if (selectedDate.isAfter(today, 'day')) {
                              setDateModalVisible(true);
                            }
                          }}
                          disabledDate={() => false}
                        />
                      ) : (
                        contract.date_of_execution &&
                        dayjs(contract.date_of_execution).format("DD-MM-YYYY")
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Effective Date" span={1}>
                      {editMode && editedContract ? (
                        <DatePicker
                          name="effective_date"
                          style={{ width: "100%" }}
                          format="DD-MM-YYYY"
                          disabledDate={() => false}
                          defaultValue={
                            contract.effective_date
                              ? dayjs(
                                dayjs(
                                  contract.effective_date,
                                  "YYYY-MM-DD"
                                ).format("DD-MM-YYYY"),
                                dateFormat
                              )
                              : null
                          }
                          onChange={(date) =>
                            setEffectiveDate(date?.format("YYYY-MM-DDTHH:mm:ss"))
                          }
                        />
                      ) : (
                        contract.effective_date &&
                        dayjs(contract.effective_date).format("DD-MM-YYYY")
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Remarks" span={2}>
                      <div className="flex justify-between">
                        <div>{contract.remarks}</div>
                      </div>
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                      {capitalizeAndRemoveUnderscores(contract.status)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Agreeement ID">
                      {contract.document_id && contract.document_id}
                    </Descriptions.Item>
                    {contract?.linked_expired_agreements?.length > 0 && (
                      <Descriptions.Item label="Linked Agreement ID">
                        {contract?.linked_expired_agreements?.length === 1 ? (
                          <span
                            className="text-blue-600 cursor-pointer flex justify-between items-center w-2/3"
                            onClick={() =>
                              navigate(`/admin/contracts/${contract?.linked_expired_agreements[0]?.linked_agreement_id}`)
                            }
                          >
                            <div>
                              {contract?.linked_expired_agreements[0]?.linked_document_id}
                            </div>
                            <ExportOutlined
                              className="text-blue-600 cursor-pointer"
                              onClick={() => {
                                setIsLinkedModalVisible(false);
                                navigate(`/admin/contracts/${contract?.linked_expired_agreements[0]?.linked_agreement_id}`);
                              }}
                            />
                          </span>
                        ) : (
                          <span
                            className="text-blue-400 cursor-pointer underline-offset-1"
                            onClick={handleOpenLinkedModal}
                          >
                            View Linked Agreements ({contract?.linked_expired_agreements.length})
                          </span>
                        )}
                      </Descriptions.Item>
                    )}


                  </Descriptions>

                </motion.div>

              </TabPane>
              <TabPane forceRender tab="Products / Services" key="2">
                <motion.div
                  className="mt-6"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <EditProductsTab created_by={contract.created_by} status={contract.status} editable_user={contract.editable_user} is_draft={contract.is_draft} allPduData={contract.product_list} handleSave={handleSave} />
                </motion.div>

              </TabPane>
              <TabPane forceRender tab="Version Control" key="3">
                <motion.div
                  className="mt-6"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className=" text-black pb-3 px-2 h-[60px] flex items-center justify-between">
                    <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                      Version Control
                    </h1>
                    <div className="flex items-center justify-end gap-3">
                      {contract && contract?.contract_history && <div className="gap-2 items-center flex flex-col justify-center">
                        <div>
                          <Button
                            type={compareMode ? "primary" : "default"}
                            danger={compareMode}
                            className={`${compareMode ? "h-10" : "h-12"} w-[15rem] rounded-[10px] border text-purple border-[#d8bfd8] transition-colors duration-300`}
                            onClick={() => {
                              if (compareMode) {
                                if (!selectedPrev || !selectedCurr) {
                                  message.warning("Please select both Previous and Current version files.");
                                  return;
                                }
                                handleChangeView(selectedPrev, selectedCurr);
                                setCompareMode(false);
                                setSelectedPrev(null);
                                setSelectedCurr(null);
                              } else {
                                setCompareMode(true);
                                setSelectedPrev(null);
                                setSelectedCurr(null);
                              }
                            }}
                          >
                            {compareMode ? "Compare Now" : "Enable Compare Mode"}
                          </Button>
                        </div>
                        <div>
                          {compareMode && (
                            <div style={{ marginBottom: 10 }}>
                              <Tag color="blue">
                                {selectedCurr ? "✅ Curr File" : "🟠 Select Curr File"}
                              </Tag>
                              <Tag color="blue">
                                {selectedPrev ? "✅ Prev File" : "🟠 Select Prev File"}
                              </Tag>
                            </div>
                          )}
                        </div>
                      </div>}
                      {contract.esign_status !== "draft" && (
                        <Button
                          onClick={handleEsignStatus}
                          type="submit"
                          className={`h-12 w-[15rem]  rounded-[10px] border border-[#d8bfd8] transition-colors duration-300 mt-8 -mr-2 mb-10 !text-purple !hover:text-[#800080] !bg-white`}
                        >
                          View E-sign Status
                        </Button>
                      )}
                    </div>

                  </div>

                  <Modal
                    title="E-sign Status"
                    centered
                    open={esignDetailModalOpen}
                    closable={false}
                    maskClosable
                    width={1000}
                    footer={
                      [
                        <Button
                          key="reminder"
                          type="primary"
                          loading={isReminderLoading}
                          onClick={handleSendReminder}
                          disabled={!pendingEmails || pendingEmails.length === 0}
                        >
                          Send Reminder
                        </Button>,
                        <Button
                          key="close"
                          type="default"
                          onClick={() => setEsignDetailModalOpen(false)}
                        >
                          Close
                        </Button>,
                      ]
                    }
                  >
                    <>
                      <div className="text-sm font-semibold my-2">
                        Signature Initiated By-
                        <span className="font-medium mx-2">
                          {signuluResponse.senderName}
                        </span>
                      </div>
                      <div className="text-sm font-semibold my-2">
                        Comments
                        <span className="font-medium mx-2">
                          {signuluResponse.addComments
                            ? signuluResponse?.addComments.map(
                              (comment, index) => {
                                return (
                                  <span key={index}>
                                    {index !== signuluResponse.length() - 1
                                      ? `${comment},`
                                      : `${comment}`}
                                  </span>
                                );
                              }
                            )
                            : "No Comments"}
                        </span>
                      </div>
                      <div className="text-sm font-semibold my-2">
                        Expiration Date-
                        <span className="font-medium mx-2">
                          {signuluResponse?.expirationDate}
                        </span>
                      </div>
                      <div className="text-sm font-semibold my-2">
                        E-sign Status-
                        <span className="font-semibold mx-2 mt-4">
                          {signuluResponse?.statusCode?.toLowerCase() ===
                            "approved" ? (
                            <span className="bg-[#479D491A] text-[#479D49] px-2 py-2">
                              {signuluResponse.statusCode}
                            </span>
                          ) : signuluResponse?.statusCode?.toLowerCase() ===
                            "rejected" ? (
                            <span className="text-[#BA3928] bg-[#BA39281A] px-2 py-2">
                              {signuluResponse.statusCode}
                            </span>
                          ) : (
                            <span className="text-[#F7CB73] bg-[#F7CB731A] px-2 py-2 ">
                              {signuluResponse.statusCode}
                            </span>
                          )}
                        </span>
                      </div>
                      <div className="">
                        <div className="text-sm font-semibold flex justify-between items-center h-10">
                          <span>Recipients Details</span>
                          {signuluResponse?.statusCode?.toLowerCase() !==
                            "pending" && (
                              <Button
                                // isLoading
                                loading={isLoading} // Show loading spinner
                                disabled={isLoading}
                                onClick={handleEsignDocDownload}
                                type="submit"
                                className="flex items-center rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10 my-0"
                              >
                                Download Signed Document
                              </Button>
                            )}
                        </div>
                        <Table
                          dataSource={signuluResponse?.recepients}
                          columns={esignColumns}
                          pagination={false}
                          scroll={{ x: "max-content" }}
                          bordered
                          className="mb-4"
                        />
                      </div>
                    </>
                  </Modal>
                  <Table
                    dataSource={
                      contract?.contract_history?.map((item, index) => ({
                        ...item,
                        key: item.id || item._id || index,
                      }))
                    }
                    columns={columns}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    bordered
                    className="mb-4"
                  />
                </motion.div>
              </TabPane>
              <TabPane forceRender tab="Custom Tab" key="4">
                <motion.div
                  className="mt-6"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="text-black pb-5 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
                    <div className="agreement-details">
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Custom Tab
                      </h1>

                      {customDFieldsCount !== 0 &&
                        role &&
                        contract &&
                        ((contract.editable_user &&
                          contract.status !== "EXECUTED" &&
                          contract.status !== "TRANSACTION_CLOSED" &&
                          parseInt(user_id) ===
                          parseInt(contract.editable_user) &&
                          ((role?.toLocaleLowerCase() === "agreement controller head") ||
                            (role?.toLocaleLowerCase() === "agreement controller team"))) ||
                          (contract.is_draft &&
                            contract.created_by ===
                            user_email)) ? (
                        <>
                          {!productEditMode && editedContract && (
                            <div className="edit-icon">
                              <EditOutlined
                                onClick={handleProductEdit}
                                className="h-4 ml-2 text-lg transform scale-125"
                              />
                            </div>
                          )}
                        </>
                      ) : null}
                    </div>
                    <div className="text-black pb-3 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
                      {productEditMode ? (
                        <div className="flex justify-between">
                          <div className="flex">
                            <ButtonComp
                              width="7em"
                              text={"Cancel"}
                              onClick={handleCancel}
                              margin={"4px"}
                              textColor="#4E36A3"
                            ></ButtonComp>
                            <ButtonComp
                              width="7em"
                              type="primary"
                              onClick={() =>
                                handleSave({ custom_field: updatedCustomForm })
                              }
                              className=""
                              text={"Save"}
                              textColor="white"
                              bgColor="#4E36A3"
                            ></ButtonComp>
                          </div>
                        </div>
                      ) : (
                        <>
                          {!!role &&
                            contract &&
                            ((contract.editable_user &&
                              contract.status !== "EXECUTED" &&
                              contract.status !== "TRANSACTION_CLOSED" &&
                              parseInt(user_id) ===
                              parseInt(contract.editable_user) &&
                              ((role?.toLocaleLowerCase() === "agreement controller head") ||
                                (role?.toLocaleLowerCase() === "agreement controller team"))) ||
                              (contract.is_draft &&
                                contract.created_by ===
                                user_email)) ? (
                            <>
                              <button
                                className={`h-12 w-[15rem] rounded-[10px] border border-[#d8bfd8] transition-colors duration-300 mt-8 -mr-2 !text-purple !hover:text-[#800080] !bg-white`}
                                onClick={() => {
                                  setCustomModal(true);
                                }}
                              >
                                <PlusOutlined /> Add More
                              </button>
                            </>
                          ) : null}



                          <Modal
                            title="Add Custom Fields"
                            open={customModal}
                            onOk={() => { handleOk('Add Custom Fields') }}
                            className="custom-table-update"
                            onCancel={handleModalCancel}
                            style={{ fontSize: "24px", padding: "40px" }}
                            okText="Save"
                            okButtonProps={{
                              style: {
                                backgroundColor: "#4E36A3",
                                color: "white",
                                height: "40px",
                                width: "100px",
                              },
                            }} // Set background color for the Ok button
                            cancelButtonProps={{
                              style: {
                                backgroundColor: "",
                                color: "#4E36A3",
                                height: "40px",
                                width: "100px",
                              },
                            }} // Set background color for the Cancel button
                          >
                            <Form autoComplete="off" form={customFieldsForm} onFinish={handleCustomFieldSave}>
                              {customFields.map((field, index) => {
                                const fieldIndex = index + findMaxIndex(contract && contract.custom_field);
                                return (
                                  <Row gutter={16} key={field.id}> {/* Ensure each row has a unique key */}
                                    <Col xs={24} sm={24} md={8} lg={8}>
                                      <Form.Item
                                        label={`Particular ${fieldIndex + 1}`}
                                        name={`field${field.id}`}
                                        rules={[
                                          { required: true, message: 'Please enter your name!' },
                                        ]}
                                      >
                                        <Input
                                          value={field?.field}
                                          onChange={(e) =>
                                            handleCustomFieldChange(index, e.target.value, field.value, field.id)
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8}>
                                      <Form.Item
                                        label={`Details ${fieldIndex + 1}`}
                                        name={`value${field.id}`}
                                        rules={[
                                          { required: true, message: 'Please enter your name!' },
                                        ]}
                                      >
                                        <Input.TextArea
                                          value={field?.value}
                                          onChange={(e) =>
                                            handleCustomFieldChange(index, field.field, e.target.value, field.id)
                                          }
                                          style={{ height: '32px' }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8}>
                                      <Button
                                        type="danger"
                                        onClick={() => handleRemoveCustomField(index)}
                                      >
                                        <DeleteOutlined />
                                      </Button>
                                    </Col>
                                  </Row>
                                );
                              })}
                            </Form>
                            <Button
                              type="dashed"
                              onClick={handleAddCustomField}
                              className="mb-4"
                              block
                            >
                              <PlusCircleOutlined />
                              Add Custom Field
                            </Button>
                          </Modal>
                        </>
                      )}
                    </div>
                  </div>

                  <Table
                    dataSource={combinedCustomList}
                    columns={customTabColumns}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    bordered
                    className="mb-4"
                  />
                </motion.div>
              </TabPane>
              <TabPane forceRender tab="User Access" key="5">
                <motion.div
                  className="mt-6"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className=" text-black pb-3 px-2 h-[60px] flex items-center justify-between">
                    <span>
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Contract Access Users
                      </h1>
                    </span>
                    <>
                      <>
                        {contract.status !== "EXECUTED" &&
                          role &&
                          contract &&
                          contract.editable_user &&
                          parseInt(user_id) ===
                          parseInt(contract.editable_user) &&
                          contract.status !== "TRANSACTION_CLOSED" && (

                            <ButtonComp
                              text="+ Add Access User"
                              bgColor="white"
                              textColor="#4E36A3"
                              onClick={showUserAddModal}
                            ></ButtonComp>
                          )}

                        <Modal
                          title="Add User"
                          open={isUserAddModalVisible}
                          onOk={() => { handleOk('Add User') }}
                          onCancel={handleModalCancel}
                          okText="Save"
                        >
                          <Form form={addUserForm} onFinish={handleAddUserSubmit}>
                            <Form.Item
                              name="user_email"
                              label="Select User"
                              rules={[
                                {
                                  type: "email",
                                  message: "The input is not valid E-mail!",
                                },
                                {
                                  required: true,
                                  message: "Please enter user E-mail!",
                                },
                              ]}
                            >
                              <Select
                                options={companyUsers.sort((a, b) =>
                                  a.label.localeCompare(b.label)
                                )}
                                isMulti
                                required
                                closeMenuOnSelect={false}
                              // onChange={handleReceiversEmailChange}
                              />
                            </Form.Item>
                          </Form>
                        </Modal>
                      </>
                    </>
                  </div>
                  <Row gutter={[16, 16]}>
                    {contract &&
                      contract.contract_access_users &&
                      contract.contract_access_users.map((user) => (
                        <>
                          <Col xs={24} sm={16} md={12} lg={8} xl={8}>
                            <Card
                              hoverable
                              title={`${user.first_name} ${user.last_name ? user.last_name : ""
                                }`}
                              bordered={false}
                              extra={
                                <Popconfirm
                                  title="Remove this user"
                                  description="Are you sure to remove this user?"
                                  onConfirm={() =>
                                    handleAddUserSubmit({
                                      user_email: user.email,
                                      assign: false,
                                    })
                                  }
                                  onCancel={handleCancel}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  {role &&
                                    contract &&
                                    contract.is_draft &&
                                    contract.created_by ===
                                    user_email ? (
                                    <>
                                      {!editMode &&
                                        editedContract &&
                                        user.email !==
                                        user_email && (
                                          <Button danger>Remove</Button>
                                        )}
                                    </>
                                  ) : null}
                                </Popconfirm>
                              }
                              className="mb-3 ml-1 mr-1 user-card"
                            >
                              <div>
                                <div>
                                  <span className="font-bold">Role : </span>{" "}
                                  {user.role}
                                </div>
                                <div>
                                  {/* <span className="font-bold">Email : </span> */}
                                  <Text className="email">
                                    Email : {user.email}
                                  </Text>
                                </div>
                                <div>
                                  <span className="font-bold">Department : </span>
                                  {user.department && user.department.name}
                                </div>
                              </div>
                            </Card>
                          </Col>
                        </>
                      ))}
                  </Row>
                </motion.div>
              </TabPane>
              <TabPane forceRender tab="Other Attachments" key="6">
                <motion.div
                  className="mt-6"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className=" text-black pb-3 px-2 h-[60px] flex items-center justify-between">
                    <span className="flex flex-row justify-between align-middle text-center">
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Other Attachments
                      </h1>
                    </span>
                    <div>
                      {role &&
                        contract &&
                        ((contract.editable_user &&
                          contract.status !== "EXECUTED" &&
                          contract.status !== "TRANSACTION_CLOSED" &&
                          parseInt(user_id) ===
                          parseInt(contract.editable_user)) ||
                          (contract.is_draft &&
                            contract.created_by ===
                            user_email)) ? (
                        <>
                          <ButtonComp
                            text="Add Attachments"
                            bgColor="white"
                            textColor="#4E36A3"
                            onClick={handleAttachemntClick}
                          />
                        </>
                      ) : null}
                    </div>
                    <Modal
                      title="Add Attachments"
                      open={attachmentModal}
                      onOk={() => { handleOk('Add Attachments') }}
                      className="attachment-modal"
                      onCancel={handleModalCancel}
                      style={{ fontSize: "24px", padding: "40px" }}
                      footer
                    >
                      <div className="p-4">
                        <Row className="mb-2">
                          <Col span={8}>Brief Particulars</Col>
                          <Col span={8}>Attachment</Col>
                          <Col span={8}></Col>
                        </Row>
                        <Row>
                          <Form form={addAttachmentsForm} onFinish={handleAddUserSubmit}>
                            {formFields.map((field, index) => (
                              <div
                                key={field.id}
                                className="flex items-center text-center mb-4 justify-center"
                              >
                                <Col span={8}>
                                  <Form.Item
                                    name="brief_particulars"
                                    className="flex flex-row attachment-input"
                                  >
                                    <Input required />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item
                                    name="attachment"
                                    valuePropName="fileList"
                                    getValueFromEvent={(e) => e.fileList}
                                    className="mr-2 attachment-input"
                                  >
                                    <Input
                                      type="file"
                                      onChange={(e) =>
                                        setFilename(e.target.files[0])
                                      }
                                      className="form-control"
                                      accept=".doc, .docx"
                                      required
                                    ></Input>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Button
                                    type="primary"
                                    onClick={() => handleAttachmentSave(index)}
                                    className="mr-2"
                                    loading={uploading}
                                    disabled={!fileName}
                                  >
                                    Save
                                  </Button>
                                </Col>
                              </div>
                            ))}
                          </Form>
                        </Row>
                      </div>
                    </Modal>
                  </div>
                  <Table
                    dataSource={attachments}
                    columns={attchmentsColumns}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    bordered
                    className="mb-4"
                  />
                </motion.div>
              </TabPane>
            </Tabs>
          </div>
          <div
            style={{
              position: "relative",
              bottom: 0,
              left: 0,
              display: "flex",
              justifyContent: "flex-start",
              // backgroundColor: "#EBE8F7",
              paddingTop: "30px",
            }}
          >
            {activeTab !== "1" && (
              <ButtonComp
                text="Previous"
                textColor="#4E36A3"
                bgColor="white"
                onClick={handlePrevious}
                margin="2rem"
              />
            )}
            {parseInt(activeTab) !== parseInt(finalPage) ? (
              <>
                {editMode ? (
                  ""
                ) : (
                  <ButtonComp
                    text="Next"
                    bgColor="#4E36A3"
                    textColor="white"
                    onClick={handleNext}
                  />
                )}
              </>
            ) : (
              <>
                {editMode ? (
                  ""
                ) : (
                  <ButtonComp
                    text="Finish"
                    bgColor="#4E36A3"
                    textColor="white"
                    onClick={handleNext}
                  />
                )}
              </>
            )}
          </div>
        </>
      ) : (
        ""
      )}
      {contract?.id && <Chat id={contract?.id} />}
    </>
  );
}

export default ContractDetailComp;
